/**
 * Enum for RelAttribute.
 */
export var RelAttribute;
(function (RelAttribute) {
    RelAttribute["PreventReferrer"] = "noopener noreferrer";
    RelAttribute["PreventReferrerAndFollow"] = "noopener noreferrer nofollow";
})(RelAttribute || (RelAttribute = {}));
;
//# sourceMappingURL=ExternalLink.js.map